import { ToggleButtonGroup, type ToggleButtonGroupProps } from '@mui/material';
import { forwardRef } from 'react';

/**
 * @tier molecule
 *
 * Segmented single-choice control (e.g. the USD | Units toggle). Defaults to
 * `exclusive` + `size="small"`; styling lives in the `MuiToggleButtonGroup`
 * theme override.
 */
export type VyToggleButtonGroupProps = ToggleButtonGroupProps;

export const VyToggleButtonGroup = forwardRef<HTMLDivElement, VyToggleButtonGroupProps>(
  function VyToggleButtonGroup({ exclusive = true, size = 'small', ...rest }, ref) {
    return <ToggleButtonGroup ref={ref} exclusive={exclusive} size={size} {...rest} />;
  },
);
